import { App } from './components/emailBindTable.vue'

//import {Type} from 'main.core'

export class EmailBinder
{
    constructor(options)
    {
        BX.Vue3.BitrixVue.createApp({
            components: { App },
            data() { 
                return {
                    messageId: options.data.messageId, 
                    endpointUrl: options.data.endpointUrl,
                    langPack: options.data.langPack,
                    imageUrl: options.data.imageUrl
                } 
            },
            template: `
				<div>
					<App    :message-id="messageId"
							:image-url="imageUrl"
							:endpoint-url="endpointUrl"
							:lang-pack="langPack"
                    />
				</div>
			`,
        }).mount(options.appEl);	
    }
}